

















































































import { BusinessUnit, Company } from '@/models'
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import ApiClient from '@/services/api-client'

@Component
export default class UpsertBusinessUnitModal extends Vue {
  @Prop({ required: false }) businessUnit: BusinessUnit

  private businessUnitSave: BusinessUnit = {
    id: '',
    name: '',
    companyId: undefined,
    createdOn: '',
    updatedOn: ''
  }

  private companies: Company[] = []

  @Watch('businessUnit', { deep: true })
  onBusinessUnitChanged() {
    this.updateBusinessUnit()
  }

  get newBusinessUnit(): boolean {
    return this.businessUnit == null || !this.businessUnit.id
  }

  async mounted() {
    await this.loadCompanies()
  }

  private async loadCompanies() {
    try {
      this.companies = await ApiClient.getCompanies()
    } catch (error) {
      console.error('Error loading companies:', error)
    }
  }

  private updateBusinessUnit() {
    if (this.businessUnit && this.businessUnit.id) {
      Vue.set(this.businessUnitSave, 'id', this.businessUnit.id)
      Vue.set(this.businessUnitSave, 'name', this.businessUnit.name)
      Vue.set(this.businessUnitSave, 'companyId', this.businessUnit.companyId)
    } else {
      this.clearForm()
    }
  }

  private formOk(): boolean {
    return !!this.businessUnitSave.id && !!this.businessUnitSave.name
  }

  hideModal() {
    this.$bvModal.hide('UpsertBusinessUnitModal')
  }

  private saveForm(): void {
    if (!this.formOk()) {
      alert('Form not valid!')
      return
    }
    const promise = this.newBusinessUnit
      ? ApiClient.createBusinessUnit(this.businessUnitSave)
      : ApiClient.updateBusinessUnit(this.businessUnitSave.id, this.businessUnitSave)

    promise
      .then((businessUnitSaved: BusinessUnit) => {
        this.$emit('businessUnitSaved', businessUnitSaved)
        this.hideModal()
        this.clearForm()
      })
      .catch((ex: Error) => alert(`Error: ${ex.message}`))
  }

  private clearForm() {
    Vue.set(this.businessUnitSave, 'id', '')
    Vue.set(this.businessUnitSave, 'name', '')
    Vue.set(this.businessUnitSave, 'companyId', null)
  }
}
